// extracted by mini-css-extract-plugin
export default {"innerWrapper":"fy-z","tooltipWrapper":"gy-z","icon":"hy-z","tooltip":"iy-z","content":"jy-z"};